/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { DynamicPropertyCardsProps } from './DynamicPropertyCards.types';
import { StyledOfferCardsDiv } from './DynamicPropertyCards.styles';
import { DynamicPropertyCardsWrapper } from './DynamicPropertyCardsWrapper';

export const DynamicPropertyCardsWrapperConfig = {
  emptyLabel: 'DynamicPropertyCards',
  isEmpty: () => true, //used when component is dropped initially in AEM
  resourceType: `mi-aem-leisure-spa/components/dynamicpropertycards`,
};

export const DynamicPropertyCardsComponentWrapper: React.FC<DynamicPropertyCardsProps> = props => {
  return <DynamicPropertyCardsWrapper {...props} />;
};

export const DynamicPropertyCards = (props: any) => {
  return !props.model.isAuthor ? (
    <div className={`m-container-fullbleed ${props?.model?.styleclass}`}>
      <StyledOfferCardsDiv>
        <DynamicPropertyCardsComponentWrapper {...props} />
      </StyledOfferCardsDiv>
    </div>
  ) : (
    <EditableComponent config={DynamicPropertyCardsWrapperConfig} {...props}>
      <div className={`m-container-fullbleed ${props?.model?.styleclass || ''}`}>
        <StyledOfferCardsDiv data-testid={'DynamicPropertyCards'}>
          <DynamicPropertyCardsComponentWrapper {...props} />
        </StyledOfferCardsDiv>
      </div>
    </EditableComponent>
  );
};
